import { render, staticRenderFns } from "./OpeningHoursList.vue?vue&type=template&id=55b8237d&"
import script from "./OpeningHoursList.vue?vue&type=script&lang=js&"
export * from "./OpeningHoursList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b8237d')) {
      api.createRecord('55b8237d', component.options)
    } else {
      api.reload('55b8237d', component.options)
    }
    module.hot.accept("./OpeningHoursList.vue?vue&type=template&id=55b8237d&", function () {
      api.rerender('55b8237d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/store/opening-hours/OpeningHoursList.vue"
export default component.exports